<app-navbar-style-three></app-navbar-style-three>

<ng-container *ngIf="foundnews != null">
  <!-- Hero Section -->
  <section class="news-detail-hero">
    <div class="container">
      <div class="news-detail-hero__content">
        <a routerLink="/news-and-events" class="breadcrumb-link">
          <svg class="breadcrumb-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Back to News & Events
        </a>
        <h1 class="news-detail-hero__title">{{ foundnews.TitleEn }}</h1>
        <div class="news-detail-hero__meta">
          <span class="meta-item" *ngIf="foundnews.PublishedDate">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12.6667 2.66667H3.33333C2.59695 2.66667 2 3.26362 2 4V13.3333C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3333V4C14 3.26362 13.403 2.66667 12.6667 2.66667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10.6667 1.33333V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.33333 1.33333V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 6.66667H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ foundnews.PublishedDate | date: 'MMMM d, yyyy' }}
          </span>
        </div>
      </div>
    </div>
  </section>

  <!-- Main Content -->
  <article class="news-detail-article">
    <div class="container">
      <div class="news-detail-content">
        <!-- Featured Image -->
        <div class="featured-image" *ngIf="foundnews.ShowAttachments && foundnews.ShowAttachments.length > 0">
          <img 
            [src]="foundnews.ShowAttachments[0].FilePath" 
            [alt]="foundnews.TitleEn"
            class="featured-image__img"
          />
        </div>

        <!-- Article Body -->
        <div class="article-body" [innerHTML]="foundnews.DetailsEn"></div>

        <!-- Image Gallery -->
        <div class="image-gallery" *ngIf="foundnews.ShowAttachments && foundnews.ShowAttachments.length > 1">
          <h3 class="image-gallery__title">Gallery</h3>
          <div class="image-gallery__grid">
            <a 
              *ngFor="let image of foundnews.ShowAttachments; let i = index"
              [href]="image.FilePath"
              [title]="foundnews.TitleEn + ' - Image ' + (i + 1)"
              class="image-gallery__item"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img 
                [src]="image.FilePath" 
                [alt]="foundnews.TitleEn + ' - Image ' + (i + 1)"
                class="image-gallery__img"
                loading="lazy"
              />
              <div class="image-gallery__overlay">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </a>
          </div>
        </div>

        <!-- Back Button -->
        <div class="article-footer">
          <a routerLink="/news-and-events" class="btn-back">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Back to All News
          </a>
        </div>
      </div>
    </div>
  </article>
</ng-container>

<!-- Loading/Error State -->
<div class="empty-state" *ngIf="foundnews == null">
  <div class="container">
    <p class="empty-state__text">News article not found.</p>
    <a routerLink="/news-and-events" class="btn-back">Return to News & Events</a>
  </div>
</div>